import React, { FC } from "react";
import { PureVoidFunc } from "../../../../helpers/functions/types";
import { Button } from "../../../../ui/layout/molecules/Button";

const DYNAMIC_FORM_SECTION_LINK_STYLE =
  "block w-full p-5 text-left text-sm font-medium text-black underline hover:text-stone-900 dark:text-white dark:hover:text-stone-100";

export type ShowAllButtonProps = {
  title: string;
  showAll: boolean;
  handleShow: PureVoidFunc;
  disabled?: boolean;
  disabledMessage?: string;
};
export const ShowAllButton: FC<ShowAllButtonProps> = ({
  title,
  showAll,
  handleShow,
  disabled,
  disabledMessage,
}) => {
  const buttonTitle =
    disabled && disabledMessage
      ? disabledMessage
      : `${showAll ? "Hide" : "Show"} ${title === "plans" ? "Inactive" : "Earlier"} ${title}`;

  return (
    <Button
      buttonType="custom"
      className={DYNAMIC_FORM_SECTION_LINK_STYLE}
      onClick={handleShow}
      title={buttonTitle}
      disabled={disabled}
    />
  );
};
